export const removeQuotes = (query: string) => query.replace(/['"]+/g, '');
